export enum AdvisoryExitPlanModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
